export function joinPathsStringUtil (...paths) {
  return paths.join('.')
}

export function joinPathsSlugStringUtil (...paths) {
  return paths.join('-')
}
